export default "__VITE_ASSET__CjLjRMfK__"